import {ILocation} from "@game/game";
import {CSSProperties, useEffect, useState} from "react";
import {TILE_SIZE} from "@components/core/theme";
import {Vector2} from "@utility/vector2";
import {MapSize} from "@game/map/mapSize";

const FadeInTime = 1000;
const FadeOutTime = 3000;

const styles: Record<string, CSSProperties> = {
    tile: {
        backgroundColor: "darkblue",
        position: "absolute",
        height: TILE_SIZE.y,
        width: TILE_SIZE.x,
    },
    fadeIn: {
        opacity: 1,
        transition: `all ${FadeInTime}ms linear`
    },
    fadeOut: {
        opacity: 0,
        transition: `all ${FadeOutTime}ms linear`
    }
};

interface IFloodEvent {
    mapSize: MapSize
    offset: Vector2
    onComplete: () => void
    tiles: ILocation[]
}
export function FloodEvent({mapSize, offset, onComplete, tiles}: IFloodEvent) {
    const [fadeIn, setFadeIn] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);
    const tileStyle: CSSProperties = {
        ...styles.tile,
        ...fadeIn ? styles.fadeIn : null,
        ...fadeOut ? styles.fadeOut : null
    }

    useEffect(() => {
        if (fadeIn) {
            setTimeout(() => {
                setFadeIn(false);
            }, FadeInTime);
        }
    }, [fadeIn]);
    useEffect(() => {
        if (! fadeIn) {
            setFadeOut(true);
            setTimeout(() => {
                onComplete();
            }, FadeOutTime);
        }
    }, [fadeIn]);
    return (
        <div>
            {tiles.map((tile, index) => {
                const position = mapSize.getTilePosition(tile).multiply(TILE_SIZE);

                return (
                    <div key={index} style={{
                        ...tileStyle,
                        ...position.toStyleLocation()
                    }}/>
                );
            })}
        </div>
    );
}